import helpers from './helpersShared';

export default {
  setValuesLoaded(state, payload) {
    state.valuesLoaded = payload;
  },
  setStaticColumns(state, payload) {
    state.staticColumns = helpers.prepareOptionsLocale(payload);
  },
  setJiraColumns(state, payload) {
    state.jiraColumns = Array.isArray(payload) ? payload : [];
  },
  setCustomColumns(state, payload) {
    const columns = helpers.prepareCustomColumnsData(payload);
    const columnsMap = columns.reduce((acc, item) => {
      const { id } = item;

      if (!acc[id]) {
        acc[id] = item;
      }

      return acc;
    }, {});

    state.columns = columns;
    state.columnsMap = columnsMap;
  },
  setProjectColumns(state, payload) {
    if (Array.isArray(payload)) {
      state.projectColumns = payload;
    } else {
      state.projectColumns = [payload];
    }
  },

};
